/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to specify a Mnemonic string which comes into play when the Mnemonics mode is turned on. The
 * string specified here is the character key combination used with Alt in the mnemonics mode to invoke a click on the
 * focusNode of the widget. For example: "A" or "XB".
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This only requires the focusNode of the Widget.
 *
 * @module MW/toolstrip/mixins/property/MnemonicsMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {

        /**
         * @property  {string} mnemonic
         * @instance
         */
        mnemonic: "",

        postCreate: function () {
            this.inherited(arguments);
            this._updateMnemonicInDOM(this.get("mnemonic"));
        },

        _setMnemonicAttr: function (mnemonic) {
            if (typeof mnemonic !== "string") {
                throw new Error("mnemonic property expects a String!");
            }

            if (this._started) {
                this._updateMnemonicInDOM(mnemonic);
            }

            this._set("mnemonic", mnemonic);
        },

        _updateMnemonicInDOM: function (mnemonic) {
            if (mnemonic.length > 0) {
                if (mnemonic.split("").some(function (character) {
                    return character.charCodeAt(0) < 65 || character.charCodeAt(0) > 90;
                })) {
                    throw new Error("mnemonic property should be a String of uppercase characters!")
                }

                this.focusNode.setAttribute("data-mnemonic", mnemonic);
            }
        }
    });

});